var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    enableBackground: "new 0 0 28 28",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4D4BB6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M2.794,15.186v-2.887 c0-5.871,4.716-10.586,10.586-10.586c5.87,0,10.586,4.716,10.586,10.586v2.887"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4D4BB6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M23.967,15.186c0,5.294-3.849,9.721-8.949,10.491 c-0.867,0.096-1.637-0.577-1.637-1.444l0,0c0-0.77,0.578-1.348,1.348-1.348l0,0c0.866,0,1.539,0.675,1.539,1.54v0.385"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4D4BB6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M6.644,11.336c-2.117,0-3.85,1.732-3.85,3.849 c0,2.118,1.732,3.851,3.85,3.851V11.336z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4D4BB6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M20.118,19.036c2.117,0,3.849-1.732,3.849-3.851 c0-2.117-1.731-3.849-3.849-3.849V19.036z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.6f006b1938c655a6088d12fff272a904.svg";
export { ForwardRef as ReactComponent };